import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { WeekSwitcherModel } from './week-switcher.types';
import { translateAnimation } from 'src/app/animations/translate.animation.';

const TRANSLATE_ANIMATION_DURATION = 100;

@Component({
  selector: 'app-week-switcher',
  templateUrl: './week-switcher.component.html',
  styleUrls: ['./week-switcher.component.scss'],
  animations: [
    translateAnimation(
      TRANSLATE_ANIMATION_DURATION,
      TRANSLATE_ANIMATION_DURATION
    ),
  ],
})
export class WeekSwitcherComponent implements OnInit {
  @HostBinding('disabled')
  @Input()
  disabled: boolean = false;
  @Input() shouldDisplayNextWeekButton: boolean = true;
  @Input() selectedWeekId: number = 0;

  @Output() weekChanged = new EventEmitter<number>();

  public readonly switcherModel: WeekSwitcherModel = {
    items: [],
  };

  selectedWeekIdForAnimationView: number = 0;

  constructor() {}

  ngOnInit() {
    this.initSwitcherModel();
  }

  ngOnChanges() {
    this.selectedWeekIdForAnimationView = this.selectedWeekId;
  }

  onPreviousWeek(): void {
    this.selectedWeekId--;
    this.weekChanged.next(this.selectedWeekId);

    setTimeout(() => {
      this.selectedWeekIdForAnimationView--;
    }, TRANSLATE_ANIMATION_DURATION);
  }

  onNextWeek(): void {
    this.selectedWeekId++;
    this.weekChanged.next(this.selectedWeekId);

    setTimeout(() => {
      this.selectedWeekIdForAnimationView++;
    }, TRANSLATE_ANIMATION_DURATION);
  }

  private initSwitcherModel(): void {
    this.switcherModel.items.push(
      {
        id: 0,
        i18nLabel: '@components.weekSwitcher.thisWeek',
      },
      {
        id: 1,
        i18nLabel: '@components.weekSwitcher.nextWeek',
      }
    );
  }
}
